import { useGetConfig } from '../chat/ChatBot';
import { useIsMobileWidget } from '../utils/device';
import type { QuickStartPlacement } from './useFetchWidgetConfig';

/**
 * Resolves the effective quick start placement for the current viewport.
 *
 * Acceptance criteria: "On phones and small viewports, buttons always appear
 * within the chat regardless of this setting." We mirror that rule here so
 * every widget surface that branches on placement gets the same answer.
 */
export function useEffectiveQuickStartPlacement(): QuickStartPlacement {
  const config = useGetConfig();
  const isMobile = useIsMobileWidget();
  if (isMobile) return 'within_chat';
  return config.quickStartPlacement ?? 'within_chat';
}
